import * as api from "@/api/williams/testEvents";
import { queryKeys } from "../../queryKeys";
import { TestEventResults } from "@/api/williams/testEvents";
import { transform } from "./useTestResults";
import { useMutation, useQueryClient } from "react-query";

export function useSubmitTestResults() {
  const queryClient = useQueryClient();

  return useMutation(async (results: TestEventResults) => {
    const updatedResults = await api.submitTestResults(results);
    queryClient.removeQueries(queryKeys.testEvent.single(results.testEvent.id));
    return transform(updatedResults);
  });
}
